import styled from '@emotion/styled';

const ExplicitLyricsWrapper = styled('span')({
  lineHeight: '2.1rem',
  margin: '-1.5rem 0 0 1.1rem',
  verticalAlign: 'middle',
});

export default ExplicitLyricsWrapper;
